module.exports = __webpack_public_path__ + "static/img/tuilogo.5b88591.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/tuilogo.png
// module id = 604
// module chunks = 1